export const accommodationTypes = {
    HOTEL: 'HOTEL',
    APARTMENT: 'APARTMENT',
    RESORT: 'RESORT',
    VILLA: 'VILLA',
    GUEST_HOUSE: 'GUEST_HOUSE',
    BUNGALOW: 'BUNGALOW',
    LODGE: 'LODGE',
    COTTAGE: 'COTTAGE',
    HOMESTAY: 'HOMESTAY',
    BOUTIQUE_HOTEL: 'BOUTIQUE_HOTEL',
    BEACH_HOTEL: 'BEACH_HOTEL',
}


export const experienceTypes = {
    ADVENTURE: 'ADVENTURE',
    CULTURE: 'CULTURE',
    LEISURE: 'LEISURE',
    NATURE: 'NATURE',
    RELAXATION: 'RELAXATION',
    SHOPPING: 'SHOPPING',
    SIGHTSEEING: 'SIGHTSEEING',
    SPORTS: 'SPORTS',
    WELLNESS: 'WELLNESS',
    WILDLIFE: 'WILDLIFE',
    FAMILY: 'FAMILY',
}

export const TravelTypes = {
    SOLO: 'SOLO',
    COUPLE: 'COUPLE',
    FAMILY: 'FAMILY',
    FRIENDS: 'FRIENDS',
    GROUP: 'GROUP',
    BUSINESS: 'BUSINESS',
}

export const IDENTITY_TYPES = {
    PASSPORT: 'PASSPORT',
    DRIVING_LICENSE: 'DRIVING_LICENSE',
    NATIONAL_ID: 'NATIONAL_ID',
    RESIDENCE_PERMIT: 'RESIDENCE_PERMIT',
    VISA: 'VISA',
    OTHER: 'OTHER',
}

export const countryList = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas (the)",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia (Plurinational State of)",
    "Bonaire, Sint Eustatius and Saba",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory (the)",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cayman Islands (the)",
    "Central African Republic (the)",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands (the)",
    "Colombia",
    "Comoros (the)",
    "Congo (the Democratic Republic of the)",
    "Congo (the)",
    "Cook Islands (the)",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Curaçao",
    "Cyprus",
    "Czechia",
    "Côte d'Ivoire",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic (the)",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Falkland Islands (the) [Malvinas]",
    "Faroe Islands (the)",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories (the)",
    "Gabon",
    "Gambia (the)",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard Island and McDonald Islands",
    "Holy See (the)",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran (Islamic Republic of)",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea (the Democratic People's Republic of)",
    "Korea (the Republic of)",
    "Kuwait",
    "Kyrgyzstan",
    "Lao People's Democratic Republic (the)",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands (the)",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia (Federated States of)",
    "Moldova (the Republic of)",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands (the)",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger (the)",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Northern Mariana Islands (the)",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine, State of",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines (the)",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Republic of North Macedonia",
    "Romania",
    "Russian Federation (the)",
    "Rwanda",
    "Réunion",
    "Saint Barthélemy",
    "Saint Helena, Ascension and Tristan da Cunha",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Martin (French part)",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten (Dutch part)",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia and the South Sandwich Islands",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan (the)",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Sweden",
    "Switzerland",
    "Syrian Arab Republic",
    "Taiwan",
    "Tajikistan",
    "Tanzania, United Republic of",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands (the)",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates (the)",
    "United Kingdom of Great Britain and Northern Ireland (the)",
    "United States Minor Outlying Islands (the)",
    "United States of America (the)",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela (Bolivarian Republic of)",
    "Viet Nam",
    "Virgin Islands (British)",
    "Virgin Islands (U.S.)",
    "Wallis and Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
    "Åland Islands"
];


export const destinationTypes = {
    CITY: 'CITY',
    REGION: 'REGION',
    ISLAND: 'ISLAND',
    CONTINENT: 'CONTINENT',
    WILDLIFE_PARK: 'WILDLIFE_PARK',
    THEME_PARK: 'THEME_PARK',
    WATER_PARK: 'WATER_PARK',
    ZOO: 'ZOO',
    AQUARIUM: 'AQUARIUM',
    MUSEUM: 'MUSEUM',
    GALLERY: 'GALLERY',
    LIBRARY: 'LIBRARY',
    BOTANICAL_GARDEN: 'BOTANICAL_GARDEN',
    HISTORICAL_SITE: 'HISTORICAL_SITE',
    MONUMENT: 'MONUMENT',
    ARCHEOLOGICAL_SITE: 'ARCHEOLOGICAL_SITE',
    FORTRESS: 'FORTRESS',
    CASTLE: 'CASTLE',
    PALACE: 'PALACE',
    MANSION: 'MANSION',
    LIGHTHOUSE: 'LIGHTHOUSE',
    TOWER: 'TOWER',
    BRIDGE: 'BRIDGE',
    TUNNEL: 'TUNNEL',
    DAM: 'DAM',
    WATERFALL: 'WATERFALL',
    CAVE: 'CAVE',
    BEACH: 'BEACH',
    COAST: 'COAST',
    MOUNTAIN: 'MOUNTAIN',
    HILL: 'HILL',
    LAKE: 'LAKE',
    RIVER: 'RIVER'
}

export const weatherTypes = {
    SUNNY: 'SUNNY',
    CLOUDY: 'CLOUDY',
    RAINY: 'RAINY',
    SNOWY: 'SNOWY',
    STORMY: 'STORMY',
    FOGGY: 'FOGGY',
    WINDY: 'WINDY'
}

export const months = {
    JANUARY: 'JANUARY',
    FEBRUARY: 'FEBRUARY',
    MARCH: 'MARCH',
    APRIL: 'APRIL',
    MAY: 'MAY',
    JUNE: 'JUNE',
    JULY: 'JULY',
    AUGUST: 'AUGUST',
    SEPTEMBER: 'SEPTEMBER',
    OCTOBER: 'OCTOBER',
    NOVEMBER: 'NOVEMBER',
    DECEMBER: 'DECEMBER'
}


export const attractionTypes = {
    MUSEUM: 'MUSEUM',
    GALLERY: 'GALLERY',
    LIBRARY: 'LIBRARY',
    BOTANICAL_GARDEN: 'BOTANICAL_GARDEN',
    HISTORICAL_SITE: 'HISTORICAL_SITE',
    MONUMENT: 'MONUMENT',
    ARCHEOLOGICAL_SITE: 'ARCHEOLOGICAL_SITE',
    FORTRESS: 'FORTRESS',
    CASTLE: 'CASTLE',
    PALACE: 'PALACE',
    MANSION: 'MANSION',
    LIGHTHOUSE: 'LIGHTHOUSE',
    TOWER: 'TOWER',
    BRIDGE: 'BRIDGE',
    TUNNEL: 'TUNNEL',
    DAM: 'DAM',
    WATERFALL: 'WATERFALL',
    CAVE: 'CAVE',
    BEACH: 'BEACH',
    COAST: 'COAST',
    MOUNTAIN: 'MOUNTAIN',
    HILL: 'HILL',
    LAKE: 'LAKE',
    RIVER: 'RIVER',
    WILD_LIFE_PARK: 'WILD_LIFE_PARK',
    RELIGIOUS_SITE: 'RELIGIOUS_SITE',
    ZOOLOGICAL_PARK: 'ZOOLOGICAL_PARK',
    THEME_PARK: 'THEME_PARK',
    WATER_PARK: 'WATER_PARK',
    AQUARIUM: 'AQUARIUM',
    CINEMA: 'CINEMA',
    ADVENTURE_PARK: 'ADVENTURE_PARK',
    ISLAND: 'ISLAND',
    CITY: 'CITY',
    SEA_ANIMALS: 'SEA_ANIMALS',
}

export const activityTypes = {
    ADVENTURE: 'ADVENTURE',
    CULTURE: 'CULTURE',
    LEISURE: 'LEISURE',
    NATURE: 'NATURE',
    RELAXATION: 'RELAXATION',
    SHOPPING: 'SHOPPING',
    SIGHTSEEING: 'SIGHTSEEING',
    SPORTS: 'SPORTS',
    WELLNESS: 'WELLNESS',
    WILDLIFE: 'WILDLIFE',
    FAMILY: 'FAMILY',
}

export const eventsTypes = {
    MUSIC: 'MUSIC',
    FESTIVAL: 'FESTIVAL',
    FOOD: 'FOOD',
    SPORTS: 'SPORTS',
    CULTURE: 'CULTURE',
    ART: 'ART',
    RELIGIOUS: 'RELIGIOUS',
    HOLIDAY: 'HOLIDAY',
    PARADE: 'PARADE',
    CONFERENCE: 'CONFERENCE',
    EXHIBITION: 'EXHIBITION',
    FAIR: 'FAIR',
    CARNIVAL: 'CARNIVAL',
}

export const hotelRoomTypes = {
    STANDARD_ROOM: 'STANDARD_ROOM',
    STANDARD_CITY_VIEW_ROOM: 'STANDARD_CITY_VIEW_ROOM',
    STANDARD_DOUBLE: 'STANDARD_DOUBLE',
    STANDARD_SEA_VIEW: 'STANDARD_SEA_VIEW',
    STANDARD_MOUNTAIN_VIEW: 'STANDARD_MOUNTAIN_VIEW',
    SUPERIOR_ROOM: 'SUPERIOR_ROOM',
    SUPERIOR_KING_TWIN: 'SUPERIOR_KING_TWIN',
    PREMIER_ROOM: 'PREMIER_ROOM',
    PREMIUM_OCEAN_ROOM: 'PREMIUM_OCEAN_ROOM',
    DELUXE: 'DELUXE',
    DELUXE_DOUBLE_ROOM: 'DELUXE_DOUBLE_ROOM',
    DELUXE_TENT: 'DELUXE_TENT',
    DELUXE_GARDEN_VIEW: 'DELUXE_GARDEN_VIEW',
    DELUXE_SEA_VIEW_WITH_BALCONY: 'DELUXE_SEA_VIEW_WITH_BALCONY',
    FAMILY_SUITE: 'FAMILY_SUITE',
    JUNIOR_SUITE: 'JUNIOR_SUITE',
    ATTIC_SUITE: 'ATTIC_SUITE',
    DUPLEX_SUITE: 'DUPLEX_SUITE',
    STABLE_SUITE: 'STABLE_SUITE',
    CHALET: 'CHALET',
    CLASSIC: 'CLASSIC',
    LUXURY_TENT: 'LUXURY_TENT',
    SKY_STUDIO: 'SKY_STUDIO',
    TRIPLE_ROOM: 'TRIPLE_ROOM',
    QUADRUPLE: 'QUADRUPLE',
    TWIN_DOUBLE: 'TWIN_DOUBLE',
    CABANA: 'CABANA',
    APARTMENT: 'APARTMENT',
    STARING_CATEGORY_1: 'STARING_CATEGORY_1',
    STARING_CATEGORY_HERITAGE: 'STARING_CATEGORY_HERITAGE',
    OCEAN_DELUXE_DOUBLE: 'OCEAN_DELUXE_DOUBLE',
    TRIPLE_SOFA_BED: 'TRIPLE_SOFA_BED',
    TERRACE_ROOM: 'TERRACE_ROOM',
    DOUBLE_KING_SUITE_WITH_OCEAN_VIEW: 'DOUBLE_KING_SUITE_WITH_OCEAN_VIEW',
    SINGLE_KING_SUITE_WITH_OCEAN_VIEW: 'SINGLE_KING_SUITE_WITH_OCEAN_VIEW',
    LAGOON_VILLA_ROOMS: 'LAGOON_VILLA_ROOMS',
    TWO_STORY_PRIVATE_VILLA: 'TWO_STORY_PRIVATE_VILLA',
    THREE_STORY_PRIVATE_VILLA: 'THREE_STORY_PRIVATE_VILLA',
    VILLA_QUADRUPLE: 'VILLA_QUADRUPLE',
    ENTIRE_VILLA: 'ENTIRE_VILLA',
    DOUBLE: 'DOUBLE',
    SINGLE: 'SINGLE',
}

export const hotelFacilityTypes = {
    AIR_CONDITIONING: 'AIR_CONDITIONING',
    HEATING: 'HEATING ',
    WIFI: 'WIFI',
    PARKING: 'PARKING',
    RESTAURANT: 'RESTAURANT',
    BAR: 'BAR',
    SWIMMING_POOL: 'SWIMMING_POOL',
    SPA: 'SPA',
    FITNESS_CENTER: 'FITNESS_CENTER',
    BUSINESS_CENTER: 'BUSINESS_CENTER',
    CONFERENCE_ROOM: 'CONFERENCE_ROOM',
    LAUNDRY: 'LAUNDRY',
    CONCIERGE: 'CONCIERGE',
    PET_FRIENDLY: 'PET_FRIENDLY',
    FAMILY_FRIENDLY: 'FAMILY_FRIENDLY',
    BEACHFRONT: 'BEACHFRONT',
    OCEAN_VIEW: 'OCEAN_VIEW',
    MOUNTAIN_VIEW: 'MOUNTAIN_VIEW',
    CITY_VIEW: 'CITY_VIEW',
    BALCONY: 'BALCONY',
    TERRACE: 'TERRACE',
    GARDEN: 'GARDEN',
    BBQ: 'BBQ',
    KITCHEN: 'KITCHEN',
    MINIBAR: 'MINIBAR',
    TELEPHONE: 'TELEPHONE',
    JACUZZI: 'JACUZZI',
    BATHTUB: 'BATHTUB',
    SHOWER: 'SHOWER',
    TOILETRIES: 'TOILETRIES',
    VERANDAH_BALCONY: 'Verandah / Balcony',
    QUEEN_SIZED_BED: 'Queen-sized bed',
    PRIVATE_ENSUITE_BATHROOM: 'Private Ensuite bathroom',
    LCD_TV_SATELLITE: 'LCD TV/ LCD TV with Satellite and Local Channels',
    MINI_BAR: 'Mini Bar/ Mini bar (On request)',
    IN_ROOM_SAFE: 'In-room safe / In-room digital safe',
    HAIR_DRYER: 'Hair dryer',
    TEA_COFFEE_FACILITIES: 'In-room tea/coffee making facilities',
    COMPLIMENTARY_WATER: 'Complimentary bottled water',
    HOUSEKEEPING_FACILITIES: 'housekeeping facilities',
    KING_SIZED_BED: 'King-sized bed',
    TWO_SINGLE_BEDS: 'two single beds',
    LED_TV_SATELLITE: 'LED TV/ LED TV with Satellite and Local Channels',
    PRIVATE_PLUNGE_POOL: 'Private Plunge Pool',
    OUTDOOR_DINING_AREA: 'Outdoor dining area',
    KITCHENETTE: 'Kitchenette',
    MICROWAVE_OVEN: 'Microwave Oven',
    COFFEE_MACHINE: 'Coffee machine',
    CUTLERY_CROCKERY: 'Cutlery & Crockery',
    KING_SIZE_LUXURY_BED: 'King Size Luxury Bed',
    HOT_COLD_WATER: 'Hot and cold water',
    LUXURY_BATHROOM_AMENITIES: 'Private Ensuite bathroom with luxury amenities',
    LOUNGE_AREA_SOFA: 'Lounge Area with Sofa',
    TWENTY_FOUR_HOUR_ROOM_SERVICE: '24-hour room service',
    SLIPPERS: 'Slippers',
    FAN: 'Fan',
    RAIN_SHOWERS: 'Rain showers',
    IRON_IRONING_BOARD: 'Iron and ironing board (on request)/ Iron & Iron Board',
    JUICES_HERBAL_TEA: 'Juices & herbal tea',
    DOCTOR_ON_CALL: 'Doctor on call',
    BABY_COTS: 'Baby cots (on request)',
    TV_CABLE_CHANNELS: 'TV with cable channels',
    BATHROOM_AMENITIES: 'Bathroom Amenities',
    BATHROBE_SLIPPERS: 'Bathrobe & Slippers (On request)',
    WRITING_DESK: 'Writing Desk',
    DVD_PLAYER_RENTAL: 'DVD Player with Free DVD Rental from Front Desk',
    TELEPHONE_INTERNATIONAL: 'Telephone with International Direct Dialling Facilities',
    SEPARATE_LIVING_AREA: 'Separate Living Area',
    LARGE_DINING_AREA: 'Large Dining Area',
    IPOD_DOCK: 'iPod Dock',
    BBQ_SURCHARGE: 'BBQ (surcharge)',
    KIDS_POOL: 'Kids Pool',
    SPA_TREATMENT_IN_ROOM: 'Spa treatment available in-room',
    PERSONAL_BAR: 'Personal bar',
    BEDSIDE_CHARGING_STATIONS: 'Bedside charging stations',
    WARDROBE_FACILITIES: 'Wardrobe Facilities',
    WASHING_MACHINE: 'Washing Machine',
    PANTRY_MICROWAVE_UTENSILS: 'Pantry with Microwave and Utensils',
    COMPLIMENTARY_MINERAL_WATER: 'Complimentary Mineral Water',
    CLOCK_MASTER_CONTROL: 'Clock & Master control panel',
    TEA_SPOONS_CUPS_SAUCERS: 'Tea spoons/cups/saucers',
    WATER_GLASSES: 'Water glasses',
    TISSUE_BOX_COVER: 'Tissue box cover',
    INFINITY_POOL: 'Innity Pool',
    DOUBLE_TWIN_BEDS: 'Double / TWIN BEDS',
    CONNECTING_ROOMS: 'Connecting rooms',
    ROOM_FOR_DIFFERENTLY_ABLED: 'Room For The Differently-Abled Available',
    OPEN_AIR_BATH: 'Open Air Bath',
    INDIVIDUAL_ROOM_CLIMATE_CONTROL: 'Individual room climate control',
    RFID_DOOR_LOCK: 'RFID door lock.',
    SUNBEDS: 'Sunbeds.',
    OUTDOOR_PLUNGE_POOL: 'Outdoor plunge pool.',
    SPACIOUS_LIVING_ROOM: 'Spacious living room',
    QUEEN_BEDS: 'queen beds',
    YOGA_MAT: 'Yoga mat',
    SCALE: 'Scale',
    FILTERED_WATER: 'Filtered water',
    DENTAL_KIT: 'Dental Kit',
    SHAVING_KIT: 'Shaving Kit',
    SEATING_AREA: 'Seating Area',
    MOSQUITO_REPELLENT: 'Mosquito repellent/ Vaperizer'
}

export const partnerTypes = {
    'HOTEL': 'hotels',
    'TOUR': 'tour',
    'RENTAL': 'rental',
    'TRANSPORT': 'transport',
    'EVENT': 'event',
    'RESTAURANT': 'resturant',
    'SHOP': 'shop',
}

export const vehiclesTypes = {
    'MINI_CAR': 'MINI_CAR',
    'HATCHBACK': 'HATCHBACK',
    'SEDAN': 'SEDAN',
    'SUV': 'SUV',
    'CROSSOVER': 'CROSSOVER',
    'COUPE': 'COUPE',
    'CONVERTIBLE': 'CONVERTIBLE',
    'MINIVAN': 'MINIVAN',
    'VAN': 'VAN',
    'COSTER': 'COSTER',
    'BUS': 'BUS',
}

export const transportPackageTypes = {
    'PREMIUM': 'PREMIUM',
    'BASIC': 'BASIC',
    'STANDARD': 'STANDARD',
    'ECONOMY': 'ECONOMY',
}

export const tourGuideTypes = {
    'TRADITIONAL': 'TRADITIONAL',
    'MODERN': 'MODERN',
    'CULTURAL': 'CULTURAL',
    'HISTORICAL': 'HISTORICAL',
    'NATURE': 'NATURE',
    'WILDLIFE': 'WILDLIFE',
    'ADVENTURE': 'ADVENTURE',
    'LEISURE': 'LEISURE',
    'SHOPPING': 'SHOPPING',
}


export const guideLanguages = {
    'ENGLISH': 'ENGLISH',
    'SPANISH': 'SPANISH',
    'FRENCH': 'FRENCH',
    'GERMAN': 'GERMAN',
    'ITALIAN': 'ITALIAN',
    'RUSSIAN': 'RUSSIAN',
    'CHINESE': 'CHINESE',
    'JAPANESE': 'JAPANESE',
    'KOREAN': 'KOREAN',
    'ARABIC': 'ARABIC',
    'HINDI': 'HINDI',
}

export const tourTypes = {
    ADVENTURE: 'ADVENTURE',
    CULTURE: 'CULTURE',
    LEISURE: 'LEISURE',
    NATURE: 'NATURE',
    RELAXATION: 'RELAXATION',
    SHOPPING: 'SHOPPING',
    SIGHTSEEING: 'SIGHTSEEING',
    SPORTS: 'SPORTS',
    WELLNESS: 'WELLNESS',
    WILDLIFE: 'WILDLIFE',
    FAMILY: 'FAMILY',
}

export const paymentTypes = {
    CASH: 'CASH',
    CARD: 'CARD',
    PAYPAL: 'PAYPAL',
    CHEQUE: 'CHEQUE',
    BANK_TRANSFER: 'BANK_TRANSFER',
}

export const supporRequestTypes = {
    GENERAL: 'GENERAL',
    BOOKING: 'BOOKING',
    PAYMENT: 'PAYMENT',
    CANCELLATION: 'CANCELLATION',
    REFUND: 'REFUND',
    COMPLAINT: 'COMPLAINT',
    SUGGESTION: 'SUGGESTION',
    OTHER: 'OTHER',
    FEEDBACK: 'FEEDBACK',
    REQUEST_CHANGE: 'REQUEST_CHANGE',
    PROBLEM: 'PROBLEM',
    QUESTION: 'QUESTION',
}

export const supportRequestStatus = {
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    RESOLVED: 'RESOLVED',
    CLOSED: 'CLOSED',
}

export const customEventsTypes = {
    WEDDING: 'WEDDING',
    BIRTHDAY: 'BIRTHDAY',
    ANNIVERSARY: 'ANNIVERSARY',
    CONFERENCE: 'CONFERENCE',
    HONEYMOON: 'HONEYMOON',
    ENGAGEMENT_PARTY: 'ENGAGEMENT_PARTY',
    ROMANTIC_PROPOSAL: 'ROMANTIC_PROPOSAL',
    OTHER: 'OTHER',
}

export const mealTypes = {
    ROOM_ONLY: 'ROOM_ONLY',
    BREAKFAST: 'BREAKFAST',
    LUNCH: 'LUNCH',
    DINNER: 'DINNER',
    SNACK: 'SNACK',
    DESSERT: 'DESSERT',
    DRINK: 'DRINK',
}


export const accommodationPackageTypes = {
    'PREMIUM': 'PREMIUM',
    'BASIC': 'BASIC',
    'STANDARD': 'STANDARD',
    'ECONOMY': 'ECONOMY',
}